import React from 'react'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'
import { FormGrid } from 'app/components/shared/FormGrid'
import { SmartInput } from 'app/components/formik/Input'
import { Input } from 'app/components/ui/form/Input'
import { Label } from 'app/components/ui/form/Label'
import { FormSection } from 'app/components/shared/FormSection'

export const PrimaryBankDetails: React.FC = () => {
  const { values } = useFormikContext<ProfileFormValues>()

  const makeFieldName = (fieldName: string) => `bank_account_1.${fieldName}`

  return (
    <>
      <FormSection title='Coordinate bancarie'>
        <FormGrid cols={[4, 4, 4]}>
          <SmartInput label='Banca' name={makeFieldName('bank')} required />

          <SmartInput
            label='Agenzia / Filiale'
            name={makeFieldName('agency')}
            required
          />

          <SmartInput label='IBAN' name={makeFieldName('iban')} required />
        </FormGrid>

        {/* read only */}
        <FormGrid cols={[4, 4, 4]}>
          <div>
            <Label htmlFor='ba_company_name'>Ragione Sociale</Label>
            <Input
              onChange={() => null}
              readOnly
              value={values.company_name}
              id='ba_company_name'
            />
          </div>
          <div>
            <Label htmlFor='ba_company_fiscal_code'>Codice fiscale</Label>
            <Input
              onChange={() => null}
              readOnly
              value={values.company_fiscal_code}
              id='ba_company_fiscal_code'
            />
          </div>
          <div>
            <Label htmlFor='ba_company_p_iva'>Partita Iva</Label>
            <Input
              onChange={() => null}
              readOnly
              value={values.company_vat}
              id='ba_company_p_iva'
            />
          </div>
        </FormGrid>
      </FormSection>
      <FormSection title='Persona delegata ad operare sul CC'>
        <FormGrid cols={[6, 6]}>
          <SmartInput
            label='Nome'
            name={makeFieldName('delegated_name')}
            required
          />
          <SmartInput
            label='Cognome'
            name={makeFieldName('delegated_surname')}
            required
          />
        </FormGrid>
        <FormGrid cols={[6, 6]}>
          <SmartInput
            label='Codice Fiscale'
            name={makeFieldName('delegated_fiscal_code')}
            required
          />
          <SmartInput
            label='Ruolo'
            name={makeFieldName('delegated_role')}
            required
          />
        </FormGrid>
      </FormSection>
    </>
  )
}
